import { fetchCommercialResource } from '../../../services/commercialService';
import { fetchLaunchAdmin } from '../../../services/launchCommerceService';
import { fetchNotificationResource } from '../../../services/notificationAdminService';
import { fetchSaIndividuals, fetchSaOrganizations } from '../api/saApi';

const labelOf = (item = {}) => item.displayName || item.name || item.title || item.code || item.key || item.email || item.eventId || item._id || 'Record';
const idOf = (item = {}) => item._id || item.id || item.code || item.key || item.eventId || labelOf(item);
const keywordsOf = (item = {}) => [item.code, item.key, item.email, item.slug, item.eventType, item.status, item._id, item.id].filter(Boolean).join(' ');
const shortId = (value = '') => String(value).length > 14 ? `${String(value).slice(0, 6)}…${String(value).slice(-6)}` : String(value);
const makeResults = (items, group, route, icon) => (items || []).map((item) => ({
  key: `${group}:${idOf(item)}`,
  label: labelOf(item),
  description: [item.code || item.key || item.email || item.eventType, shortId(item._id || item.id)].filter(Boolean).join(' · '),
  searchText: keywordsOf(item),
  group,
  icon,
  to: route,
}));

const settledItems = (result) => result.status === 'fulfilled' ? result.value?.items || [] : [];

export const fetchGlobalAdminSearchRecords = async (token) => {
  const [products, users, organizations, campaigns, coupons, notifications, launchEntities] = await Promise.allSettled([
    fetchCommercialResource('products', token),
    fetchSaIndividuals({ token, view: 'active' }),
    fetchSaOrganizations({ token, view: 'active' }),
    fetchCommercialResource('campaigns', token),
    fetchCommercialResource('coupons', token),
    fetchNotificationResource('events', token),
    fetchLaunchAdmin('opportunities', token),
  ]);

  return [
    ...makeResults(settledItems(products), 'Products', '/sa/monetization?section=products', 'commerce'),
    ...makeResults(users.status === 'fulfilled' ? users.value?.users : [], 'Users', '/sa/dashboard/individual', 'users'),
    ...makeResults(organizations.status === 'fulfilled' ? organizations.value?.organizations : [], 'Organizations', '/sa/organizations', 'organizations'),
    ...makeResults(settledItems(campaigns), 'Campaigns', '/sa/monetization?section=campaigns', 'growth'),
    ...makeResults(settledItems(coupons), 'Coupons', '/sa/monetization?section=coupons', 'commerce'),
    ...makeResults(settledItems(notifications), 'Notifications', '/sa/notifications', 'notifications'),
    ...makeResults(settledItems(launchEntities), 'Launch', '/sa/launch-commerce', 'launch'),
  ];
};
